module.exports = __webpack_public_path__ + "img/Carousel_Header3.9ea50972.png";